/**
 * Central mapping: peptide slug → live Saleor product slug.
 * Used by research pages (`saleor-product-map.ts`) as the allow-list for shop links.
 */
export interface PeptideLinks {
	productSlug: string;
}

export const PEPTIDE_LINKS: Record<string, PeptideLinks> = {
	"ahk-cu": { productSlug: "ahk-cu" },
	"aod-9604": { productSlug: "aod-9604" },
	b12: { productSlug: "b12" },
	"bac-water-10ml": { productSlug: "bac-water-10ml" },
	"bpc-157": { productSlug: "bpc-157" },
	cagrilintide: { productSlug: "cagrilintide" },
	"cjc-1295": { productSlug: "cjc-1295" },
	"cjc-1295-dac": { productSlug: "cjc-1295-dac" },
	"cjc-ipa-blend": { productSlug: "cjc-ipa-blend" },
	"5-amino-1mq": { productSlug: "5-amino-1mq" },
	dsip: { productSlug: "dsip" },
	epithalon: { productSlug: "epithalon" },
	"ghk-cu": { productSlug: "ghk-cu" },
	"glow-stack": { productSlug: "glow-stack" },
	ipamorelin: { productSlug: "ipamorelin" },
	"kisspeptin-10": { productSlug: "kisspeptin-10" },
	"klow-stack": { productSlug: "klow-stack" },
	kpv: { productSlug: "kpv" },
	"melanotan-1": { productSlug: "melanotan-1" },
	"mots-c": { productSlug: "mots-c" },
	"mt-2": { productSlug: "mt-2" },
	"nad-plus": { productSlug: "nad-plus" },
	pinealon: { productSlug: "pinealon" },
	"pt-141": { productSlug: "pt-141" },
	retatrutide: { productSlug: "retatrutide" },
	selank: { productSlug: "selank" },
	semaglutide: { productSlug: "semaglutide" },
	semax: { productSlug: "semax" },
	"snap-8": { productSlug: "snap-8" },
	"ss-31": { productSlug: "ss-31" },
	sermorelin: { productSlug: "sermorelin" },
	"sermorelin-acetate": { productSlug: "sermorelin" },
	survodutide: { productSlug: "survodutide" },
	"tb-500": { productSlug: "tb-500" },
	"tb500-bpc157-blend": { productSlug: "tb500-bpc157-blend" },
	tesamorelin: { productSlug: "tesamorelin" },
	"thymosin-alpha-1": { productSlug: "thymosin-alpha-1" },
	tirzepatid: { productSlug: "tirzepatid" },
	vip: { productSlug: "vip" },
	tb500: { productSlug: "tb-500" },
	"melanotan-2": { productSlug: "mt-2" },
};

export function getPeptideLinks(slug: string): PeptideLinks | null {
	return PEPTIDE_LINKS[slug] ?? null;
}
